import axios from 'axios';
import { mutate } from 'swr';

import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';
import { IUser } from './interfaces';

const BASE_URL = `/${SERVICES.USER}/users`;

export const requestCreateUser = (user: IUser) => {
  const payload = {
    ...user,
    paySystemUserId: user?.paySystemUserId ? String(user?.paySystemUserId) : null,
    phoneExtension: user?.phoneExtension ? String(user?.phoneExtension) : null,
  };
  return mutate(BASE_URL, async() => {
    try {
      await axios.post(BASE_URL, payload);
      Notistack.successMessage('User - Created Successfully');
    } catch (err) {
      const error = getError(err);
      Notistack.generalError(error);
      return { error };
    }
  });
};

export const requestUpdateUser = (user: IUser) => {
  const payload = {
    ...user,
    paySystemUserId: user?.paySystemUserId ? String(user?.paySystemUserId) : null,
    phoneExtension: user?.phoneExtension ? String(user?.phoneExtension) : null,
  };
  return mutate(BASE_URL, async() => {
    try {
      await axios.patch(`${BASE_URL}/${user.id}`, payload);
      Notistack.successMessage('User - Updated Successfully');
    } catch (err) {
      const error = getError(err);
      Notistack.generalError(error);
      return { error };
    }
  });
};

export const requestDeleteUser = (userId = '') => {
  return mutate(BASE_URL, async() => {
    try {
      await axios.delete(`${BASE_URL}/${userId}`);
      Notistack.successMessage('User - Deleted Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};
